<template>
    <div>
        <h2 class="non-printable">{{$t('SUMMARY')}}</h2>
        <hr/>
        <div class="non-printable">
            <heading-icon icon="print" :pointerCursor="true" @click="printSummary"/>
        </div>
        <hr/>
        <div class="card shadow mb-4">
            <div class="card-body">
                <div class="table-responsive border">
                    <b-table 
                        show-empty
                        striped
                        bordered
                        :items="categories"
                        :fields="fields">
                        <template v-slot:cell(category)="row">
                            <router-link :to="'categories/' + row.item.id" class="summary-category">{{row.item.title}}</router-link>
                            <p v-if="categoryStatuses.length > 0" class="status-icon m-0">
                                <icon v-if="getCategoryStatus(row.item.id) == 1" class="status-danger" icon='exclamation' />
                                <icon v-else-if="getCategoryStatus(row.item.id) == 2" class="status-success" icon='check' />
                                <icon v-else-if="getCategoryStatus(row.item.id) == 3" class="status-warning" icon='spinner' />
                            </p>
                        </template>
                        <template v-slot:cell(steps)="row">
                            <div class="summary-cell-items-container">
                                <div class="col border py-2 summary-cell-item" v-bind:class="{'bg-danger text-white': getCategoryStepStatus(step.id) == 1, 'bg-success text-white': getCategoryStepStatus(step.id) == 2}" v-for="(step,index) in row.item.steps" :key="index">
                                    <p class="cell-item-title">{{step.title}}</p>
                                    <p class="cell-item-completed" v-if="progressLogs.map(function(item) { return item.stepId; }).indexOf(step.id) >= 0">
                                        {{$t("COMPLETED_ON")}} {{progressLogs[progressLogs.map(function(item) { return item.stepId; }).indexOf(step.id)].dateTime.replace('T', ' ').slice(0,19)}}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CategoryWithStatus from '../layouts/partials/CategoryWithStatus'
import HeadingIcon from '../misc/HeadingIcon'

export default {
    components:{
        'categoryWithStatus': CategoryWithStatus,
        HeadingIcon
    },
    computed:{
        fields() {
            return [
                { key: 'category', label: this.$t('CATEGORY'), sortable: true, tdClass: 'summary-category-td' },
                { key: 'steps', label: this.$t('STEPS'), sortable: true },
            ]
        },
        categoryStatuses(){
            return this.$store.getters.categoryStatuses;
        },
        categories() {
            try {
                let self = this;
                return this.$store.getters.categoriesWithSteps.filter(function (obj) {
                    return obj.languageId == self.$store.getters.selectedLanguage.id;
                });
            }
            catch {
                return [];
            }

        },
        cgaPatientSheet: function(){
            return this.$store.getters.cgaPatientSheet;
        },
    },
    methods:{
        printSummary: function () {
            window.print();
        },
        loadProgressLogs: function(){
            let self = this;
            this.$http.get(`/api/categories/progress-logs/get-per-sheet/${this.cgaPatientSheet.id}`)
            .then(response => {
                self.progressLogs = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        getCategoryStepStatus: function(categoryStepId)
        {
            if(this.categoryStepStatuses && this.categoryStepStatuses.length > 0)
            {
                var statusIndex = this.categoryStepStatuses.map(function (item) {return item.categoryStepId}).indexOf(categoryStepId)
                return this.categoryStepStatuses[statusIndex].status;
            }
        },
        loadAllCategoryStepStatuses: function(){
            let self = this;
            this.$http.get(`/api/category-steps/statuses/${this.cgaPatientSheet.id}`)
            .then(response => {
                self.categoryStepStatuses = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        getCategoryStatus: function(categoryId)
        {
            return this.categoryStatuses[this.categoryStatuses.map(function (item) {return item.categoryId}).indexOf(categoryId)].status;
        }
    },
    data () {
        return {
            progressLogs: [],
            categoryStepStatuses: []
        }
    },
    mounted: function(){
        if(this.cgaPatientSheet != null)
        {
            this.loadProgressLogs();
            this.loadAllCategoryStepStatuses();
        }
    },
    watch:{
        cgaPatientSheet: function(){
            if(this.cgaPatientSheet != null)
            {
                this.loadProgressLogs();
                this.loadAllCategoryStepStatuses();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .cgi-category-item-container{
        margin-left: auto!important;
        ::v-deep span {
            &.category-name {
                float: left;
            }
            &.category-icon {
                float: left;
            }
        }
        vertical-align: middle;
    }

    div.row{
        margin-left: auto;
        margin-right: auto;
    }
    
    ::v-deep td {
       &:first-of-type {
           a {
               background-color: white;
               color: #428bca !important;
           }
           background-color: white !important;
       }
       padding: 0px !important;
    }

    ::v-deep .summary-cell-items-container {
        width: auto;
        display: flex; 
        background: #dddfeb;
        .summary-cell-item
        {
            background: white;
            margin: 3px;
            width: 200px;
            min-width: 200px;
            max-width: 200px;
            display: inline-block;
            position: relative;
            padding: 5px;
            padding-bottom: 20px !important;
            .cell-item-title {
                font-size: 14px;
                font-weight: bold;
            }

            .cell-item-completed {
                font-size: 10px;
                font-weight: bold;
                color: #39566e;
                position: absolute;
                bottom: 5px;
                margin: 0px;
            }

            &:first-child {
                margin-left: 6px;
            }
            &:last-child {
                margin-right: 6px;
            }
        }


        }

    ::v-deep .summary-category {
        background: #39566e;
        color: white !important;

        &:hover {
            text-decoration: underline;
        }
    }

    ::v-deep .summary-category-td {
        vertical-align: middle;
        background: #39566e;
        font-size: 14px;
        font-weight: bold;
        padding-left: 20px !important;
        padding-right: 20px !important;
    }

    ::v-deep .status-icon {
        svg
        {
            border-radius: 50%;
            width: 20px;
            height: 20px;
            text-align: center;
            color: white;
            padding: 2px;
        }

        .status-success {
            background: #1cc88a;
            border: 1px solid #14aa73;
        }

        .status-danger {
            background: #f52323;
            border: 1px solid #cc1414;
        }

        .status-warning {
            background: #ffc107;
            border: 1px solid #f0ad4e;
        }
    }
</style>

<style lang="scss">

    @media print {
        #accordionSidebar, .main-nav, .non-printable, hr, footer {
            display: none !important;
        }
        table, .card {
            overflow: visible !important;
        }
        .summary-cell-items-container {
            display: grid !important;
            grid-template-columns: repeat(4, 1fr);
            justify-items: center;

            .summary-cell-item {
                width: 100% !important;
                max-width: initial !important;
                
                &:first-child {
                    margin-left: 3px !important;
                }
                &:last-child {
                    margin-right: 3px !important;
                }
            }
        }
        table tbody tr td.summary-category-td {      
            .summary-category {
                color: #000 !important;
                background-color: #fff;
                text-decoration: none !important;
            }
        }
        #content-wrapper {
            overflow: visible !important;
            overflow-x: visible !important;
            overflow-y: visible !important;
        }
    }
</style>